import styles from './CabecalhoPDF.module.scss';
import ILC from '../../../assets/img/ILC.png';
import RDS from '../../../assets/img/RDS.png';

export default function CabecalhoPDF() {
    return (
        <div className={styles.container}>
            <img src={ILC}/>
            <h1 className={styles.title}>Pedido de Compra</h1>
            <img src={RDS}/>
        </div>
    )
}